
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BreadcrumbActions } from '../store/breadcrumb.reducer';

import { IState } from '../store/root.reducer';
import { Crumb } from '../domain/breadcrum.entity';

@Injectable()
export class BreadcrumbService {

  constructor(
    private store: Store<IState>) { }

  setBreadcrumb(activatedRoute: ActivatedRoute, enableGoBack?: boolean) {
    const crumbs = this.buildBreadCrumb(activatedRoute.root, enableGoBack);

    const icons = crumbs.filter(x => x.cssIcon);
    const icon = icons.length > 0 ? icons[0] : '';

    this.store.dispatch({
      type: BreadcrumbActions.SET_CRUMBS,
      payload: {
        crumbs: crumbs,
        icon: icon,
      }
    });
  }

  buildBreadCrumb(route: ActivatedRoute, enableGoBack, url: string = '', breadcrumbs: Crumb[] = []): Crumb[] {
    const path = route.snapshot.url.length > 0 ? route.snapshot.url[0].path : '';
    let nextUrl = url;
    let newBreadcrumbs: Crumb[] = [...breadcrumbs];
    if (path) {
      nextUrl = `${url}${path}/`;

      const breadcrumb: Crumb = {
        link: nextUrl,
        label: route.snapshot.data['breadcrumbTitle'],
        subtitle: route.snapshot.data['breadcrumbSubtitle'],
        goBack: enableGoBack ? enableGoBack : false,
        previous: route.snapshot.data['breadcrumbPrevious'],
        cssIcon: route.snapshot.data['breadcrumbCssIcon'],
      };
      newBreadcrumbs = [...breadcrumbs, breadcrumb];
    }

    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, enableGoBack, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
}
